export default {
  title: 'That page does not exist',
  helper: 'Oops!',
  button: 'Go to homepage'
};
